import { bus_nhaxe } from "../../../models/response/bus/bus_nhaxe";
import {
	eBusNhaXeActionTypeIds, IBusNhaXeChangeSelectedIds, IBusNhaXeCloseConfirm, IBusNhaXeCloseDetail,
	IBusNhaXeDeleteErr, IBusNhaXeDeleteStart, IBusNhaXeDeleteSuccess,
	IBusNhaXeLoadErr, IBusNhaXeLoadStart, IBusNhaXeLoadSuccess,
	IBusNhaXeSaveErr, IBusNhaXeSaveStart, IBusNhaXeSaveSuccess,
	IBusNhaXeShowConfirm, IBusNhaXeShowDetail
} from "../../action-types/bus/IBusNhaXeActionTypes";

export const busNhaXeActions = {
	loadBusNhaXeStart: (): IBusNhaXeLoadStart => {
		return {
			type: eBusNhaXeActionTypeIds.LOAD_START
		}
	},
	loadBusNhaXeSuccess: (data: bus_nhaxe[]): IBusNhaXeLoadSuccess => {
		return {
			type: eBusNhaXeActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadBusNhaXeError: (message: string): IBusNhaXeLoadErr => {
		return {
			type: eBusNhaXeActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	showBusNhaXeDetail: (data?: bus_nhaxe): IBusNhaXeShowDetail => {
		return {
			type: eBusNhaXeActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeBusNhaXeDetail: (): IBusNhaXeCloseDetail => {
		return {
			type: eBusNhaXeActionTypeIds.CLOSE_DETAIL
		}
	},
	changeBusNhaXeSelectedIds: (ids: number[]): IBusNhaXeChangeSelectedIds => {
		return {
			type: eBusNhaXeActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	showBusNhaXeConfirm: (data?: bus_nhaxe): IBusNhaXeShowConfirm => {
		return {
			type: eBusNhaXeActionTypeIds.SHOW_CONFIRM,
			payload: data
		}
	},
	closeBusNhaXeConfirm: (): IBusNhaXeCloseConfirm => {
		return {
			type: eBusNhaXeActionTypeIds.CLOSE_CONFIRM
		}
	},
	deleteBusNhaXeStart: (id: number): IBusNhaXeDeleteStart => {
		return {
			type: eBusNhaXeActionTypeIds.DELETE_START,
			payload: id
		}
	},
	deleteBusNhaXeSuccess: (): IBusNhaXeDeleteSuccess => {
		return {
			type: eBusNhaXeActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteBusNhaXeErr: (message: string): IBusNhaXeDeleteErr => {
		return {
			type: eBusNhaXeActionTypeIds.DELETE_ERROR,
			payload: message
		}
	},
	saveBusNhaXeStart: (data: bus_nhaxe): IBusNhaXeSaveStart => {
		return {
			type: eBusNhaXeActionTypeIds.SAVE_START,
			payload: data
		}
	},
	saveBusNhaXeSuccess: (): IBusNhaXeSaveSuccess => {
		return {
			type: eBusNhaXeActionTypeIds.SAVE_SUCCESS
		}
	},
	saveBusNhaXeError: (message: string): IBusNhaXeSaveErr => {
		return {
			type: eBusNhaXeActionTypeIds.SAVE_ERROR,
			payload: message
		}
	}
}
